<template>
  <div id="app" v-if="show">

    <el-container style="height: 100%">
        <el-header class="header">
         <div class="user" >
          <el-link style="color:#fff" class="el-icon-s-home" :underline="false" @click="goStudent" type="primary" v-if="myPermissions.includes('frontend')"></el-link>
        <el-dropdown>
            <span class="el-dropdown-link" style="color:#fff">
              {{username}}<i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="goLogin">退出</el-dropdown-item>
          
            </el-dropdown-menu>
          </el-dropdown>
         </div>
        </el-header>
        <el-container>
      <el-aside width="200px">

      <el-menu router :default-active="this.$route.path.replace(/[0-9]+/g,'')"  @select="handleSelect"
        active-text-color="#1E7EE5"
        unique-opened

       >

        <el-submenu v-for="(item,index) in leftArr" :index="item.route" :key="item.id"    v-if="myPermissions.includes(item.permission)" >

          <template slot="title">
            <i :class="item.icon"></i>
           <span>{{item.name}}</span>
           </template>
           <el-menu-item v-for="(subitem,index) in item.children" :index="'/'+subitem.route"  :key="subitem.id" v-if="myPermissions.includes(subitem.permission)">
            <i :class="'image'+index"></i>
              <span slot="title">{{subitem.name}}</span>
           </el-menu-item>
        </el-submenu>
        </el-menu>


      </el-aside>
      <el-container>
        <el-main>
          <div class="elmain"> 
            <router-view v-if="isShow" />
          </div>
          </el-main>
      
      </el-container>
      </el-container>
    </el-container>
   
  </div>
  <div id="app2" v-else>
    <router-view/>
  
  </div>
</template>

<script>
import ajaxObj from "@/ajax";
import Vue from "vue";

export default {
  name: 'App',
  provide () {
    return {
      reload: this.reload
    }
  },
  data(){
    return {
      myPermissions:[],
      username:'',
      show:true,
      topActive:"",
      leftActive:"",
      reload: this.reload,  //  控制表格刷新
      isShow: true,   //  控制表格刷新
      leftArr: [
      {
        name:'系统管理',
        display:"lessonManagement",
        permission:"system",
        route:"aaa",
        icon:'el-icon-setting',
        children:[
        {
            name:'案例管理',
             permission:"course",
            route:"lessonManagement",
            display:"sssss"
        },
         {
             name:'用户管理',
              permission:"user",
              route:"userManagement",
              display:"sssss"
         },
         {
             name:'角色管理',
              permission:"role",
              route:"partManagement",
              display:"sssss"
         },
          {
             name:'知识管理',
              permission:"role",
              route:"knowledgeManagement",
              display:"sssss"
         },
          {
             name:'标签管理',
              permission:"role",
              route:"tagManagement",
              display:"sssss"
         }


           

        ]
      },
       {
           name:'答疑管理',
            route:"classManagement",
             permission:"answer",
            display:"sssss",
            icon:'el-icon-notebook-2',
            children:[
              {
                name:'类别管理',
                    permission:"category",
                route:"classManagement",
                display:"sssss"
              },
              {
                name:'答疑管理',
                    permission:"question-lib-read",
                  route:"questionManagement",
                  display:"sssss"
              },
              {
                name:'学生答疑',
                    permission:"qa",
                  route:"questionList",
                  display:"sssss"
              },
               {
                name:'专家答疑',
                    permission:"qa_expert",
                  route:"expert",
                  display:"sssss"
              },
              {
                name:'入库审批',
                    permission:"approve",
                  route:"questionApproval",
                  display:"sssss"
              },
              {
                name:'我的题库',
                    permission:"question-lib-mine",
                  route:"myQuestion",
                  display:"sssss"
              }
            ]
      },
      {
          name:'教学管理',
          route:"student",
              permission:"teach",
          display:"sssss",
          icon:'el-icon-receiving',
          children:[
            {
              permission:"student",
              name:'学生管理',
              route:"student",
              display:"sssss"
            },
            {
              name:'进度管理',
                  permission:"progress",
              route:"progress",
              display:"sssss"
            },
            {
              name:'成绩管理',
                  permission:"score",
                route:"effort",
                display:"sssss"
            },
            {
              name:'下载管理',
                  permission:"download",
                route:"download",
                display:"sssss"
            },
            {
              name:'批次管理',
                  permission:"batch",
                route:"batch",
                display:"sssss"
            }
          ]
      },
      {
          name:'报告管理',
          route:"reportLibrary",
            permission:"report",
          display:"sssss",
          icon:'el-icon-notebook-1',
          children:[
            {
              permission:"report-list",
              name:'报告文库',
              route:"reportLibrary",
              display:"sssss"
            },
            {
              name:'入库审批',
                  permission:"report-audit",
              route:"treasuryApproval",
              display:"sssss"
            },
            {
              name:'我的申请',
                  permission:"report-shenqing",
                route:"myApplication",
                display:"sssss"
            },
            {
              name:'我的审批',
                  permission:"report-my-audit",
                route:"MyApproval",
                display:"sssss"
            },
            
          ]
      },
       
           



      ]
    }
  },
  methods: {
    // 控制表格刷新
    reload () {
      this.isShow= false
      this.$nextTick(function () {
      this.isShow= true
    })
    },
      handleSelect(key, keyPath) {
        //console.log(key, keyPath);
      },
    // 跳到学生页面
      goStudent(){

        let token  = window.localStorage.getItem('access_token')
        console.log(token)
       // window.location.href = process.env.studentURL+"?usertoken="+token ;
        window.open( process.env.studentURL+"?usertoken="+token,'_blank');
      },
      // 跳转到登录页
      goLogin(){

         this.$router.push("login");
      },
      init(){
         ajaxObj({url: "roles/my-permissions",method: "get"})
        .then(response => {
            this.myPermissions=response.data.data;

             this.username = window.localStorage.getItem('username');
                     console.log(this.leftArr)
            for(let item of this.leftArr){
              for(let sub of item.children){
                if(this.myPermissions.includes(sub.permission)){

                   this.$router.push(sub.route);
                   return;
                }

              }
            }
        })
      }
    },
   
  computed: {
    defaultActive() {
      return "/" + this.$route.path.split("/").reverse()[0];
    }

  },
  created(){
    //alert(11)
      
    // ajaxObj({url: "roles/my-permissions",method: "get"})
    //   .then(response => {
    //       this.myPermissions=response.data.data;
    //     })
    this.show = this.$route.path !='/courses' &&  this.$route.path !='/login' ;
    if(this.show){
      this.init()
    }
    
   
  },

   updated(){

      this.username = window.localStorage.getItem('username');
      // ajaxObj({url: "roles/my-permissions",method: "get"})
      //   .then(response => {
      //       this.myPermissions=response.data.data;
      //   })

    },
    
  
   watch: {
     $route(to, from) { 
      this.show = to.path !='/courses' &&  to.path !='/login' ;
     
     // console.log(to)
    }
  },
}
</script>

<style>
body,
div,
ul,
li,
h1,
h2,
h3,
h4,
h5,
h6,
p,
dl,
dt,
dd,
ol,
form,
input,
textarea,
th,
td,
select {
  margin: 0;

  padding: 0;
}
li{
  list-style: none;
}
html,body {
  height: 100%;
  background: #ECEEF2;
  margin-top:0;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 0px;
  height:100%;
}

.el-menu,.el-menu-item {
  list-style:none;
}
.router-link-active{
  text-decoration: none;
  color: #1875f0 !important;
}

.el-menu-item a {
  text-decoration: none;
 color:#303133 ; 
}

.top-menu{
  float:right;
}
.el-aside{
  text-align:left;

}

.el-submenu.is-opened.is-active .el-submenu__title{
  background: #1E7EE5;
  border-radius: 8px;
  border-radius: 8px;
  color:#fff;
}
.el-submenu.is-opened.is-active .el-submenu__title i{color:#fff;}
.el-aside {
display: block;
position: relative;

background-color: #FFFFFF !important;
}
.el-aside .el-menu-item {
  background: #F7F7F7;
}

.el-aside .el-submenu.is-opened {
  background: #F7F7F7;
}

.el-submenu.is-opened.is-active .el-submenu__title{
   background: #1E7EE5;
  border-radius: 8px;
  border-radius: 8px;
}
.el-dropdown-link {
  cursor: pointer;
}
</style>

<style scoped>
.el-header{
 background: #1E7EE5;
}
/* .image0{
   display:inline-block;
   width: 14px;
   height: 14px;
}

.image1{
   display:inline-block;
   width: 14px;
   height: 14px;
}
.image2{
   display:inline-block;
   width: 14px;
   height: 14px;
} */
.el-main .elmain {
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  border-radius: 10px;
}
/* 顶部用户 */
.header {
  display: flex;
  flex-direction: column;
  justify-content: center; 
}
.user {
  position: absolute;
  right: 30px;
}
.el-icon-s-home {
  margin-right: 10px;
  font-size: 24px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue